import { FormProvider } from 'react-hook-form';
import { useEditUserFormBankAccount } from './hooks';
import { convertToBankAccountDisplayFields, convertToPresentationProps } from './logics';
import { EditUserFormBankAccountPresentation } from './presentations';

type Props = {
  userId: number;
};

/**
 * 利用者編集フォーム（口座連携版）のコンテナコンポーネント
 *
 * @param userId - 編集対象の利用者ID
 */
export const EditUserFormBankAccount: React.FC<Props> = ({ userId }) => {
  const {
    state: { methods, isButtonDisabled, bankAccountData, userData },
    actions: { handleOnSubmit },
  } = useEditUserFormBankAccount(userId);

  const { branchCode, accountNumber } = convertToBankAccountDisplayFields({
    data: bankAccountData,
  });

  const { isBillableFromEditable } = convertToPresentationProps({ data: userData });

  return (
    <FormProvider {...methods}>
      <EditUserFormBankAccountPresentation
        isButtonDisabled={isButtonDisabled}
        onSubmit={handleOnSubmit}
        branchCode={branchCode}
        accountNumber={accountNumber}
        isBillableFromEditable={isBillableFromEditable}
      />
    </FormProvider>
  );
};
